import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { t } from 'src/lib/language';
import { BASE_URL } from 'src/environments/environment';

interface OwnProps {
  fundraisingId: number;
}

type Props = OwnProps & ButtonProps;

const ShowTicketsForFundraisingButton = (props: Props) => {
  const { disabled, fundraisingId } = props;
  const lang = useSelector((state: Store) => state.language.language);

  const onClick = () => {
    if (!fundraisingId) return;
    window.open(`${BASE_URL}/fundraisings/tickets/${fundraisingId}`);
  };

  return (
    <Tooltip
      title={t(lang, 'menus.show_fundraisings_tickets')}
      placement="top-start">
      <span>
        <ActionButton
          category={MENU_BUTTON_CATEGORY.presets}
          onClick={onClick}
          disabled={disabled}>
          <ConfirmationNumberOutlinedIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default ShowTicketsForFundraisingButton;
